import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			rx: 13,
			fill: "#E8F5E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5469 13C19.5469 9.27344 16.5234 6.25 12.7969 6.25C9.07031 6.25 6.04688 9.27344 6.04688 13C6.04688 16.7266 9.07031 19.75 12.7969 19.75C16.5234 19.75 19.5469 16.7266 19.5469 13V13",
			stroke: "#2E7D32",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 10L11.1 16L9 13.6",
			stroke: "#2E7D32",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgActive);
export default ForwardRef;
